<template>
  <div
    v-if="isVisible"
    class="cf-card  cf-flex cf-flex--row cf-flex--align-center cf-flex--gap-16"
  >
    <img
      v-if="merchant.options.loyaltyImageUrl"
      class="cf-image cf-image--logo-smallest"
      :alt="merchant.name"
      :src="merchant.options.loyaltyImageUrl"
      onerror="this.src='/images/image-not-found.png';"
    >

    <div class="cf-flex cf-flex--column cf-flex--align-start cf-flex--gap-8">
      <h3 class="cf-title cf-title--3">
        {{ content.ReceiptLoyaltyAward.title }}
      </h3>

      <p class="cf-subtitle cf-subtitle--2">
        {{ content.ReceiptLoyaltyAward.description }}
      </p>
    </div>
  </div>
</template>


<script>
  import { mapGetters } from 'vuex';

  import events from '@/services/events';

  import parseReceiptLoyaltyRewards from '@/helpers/parse-receipt-loyalty-rewards';


  export default {
    name: 'CfLoyaltyReceiptSummary',

    props: {
      isPayAtTable: {
        type: Boolean,
        default: false
      },

      receipt: {
        type: Object,
        required: true
      }
    },

    computed: {
      ...mapGetters('content', ['content']),
      ...mapGetters('merchant', ['merchant']),
      ...mapGetters('offers', ['loyalty']),

      isVisible() {
        return this.receipt.loyaltyEngagementSummary?.loyaltyAwardDisplayFormat === 'Message';
      }
    },

    created() {
      this.createdHandler();
    },

    methods: {
      createdHandler() {
        if (this.receipt.loyaltyEngagementSummary?.loyaltyAwardDisplayFormat === 'AwardDetails') {
          const rewardsSummary = parseReceiptLoyaltyRewards(this.receipt.loyaltyEngagementSummary);
          if (rewardsSummary.earnedNewReward) {
            // this.$triggerGoogleTrackingEvent('EarnedReward', 'Loyalty');

            this.$triggerNewRelicEvent('EarnedReward', 'Information', 'Earned Reward');
          }

          events.emit('loyalty-popup-card:open', {
            disableOffersPageLink: this.isPayAtTable,
            receipt: {
              ...this.receipt,
              rewardsSummary
            },
            refreshData: true
          });
        }
      }
    }
  };
</script>
